import React, { useEffect, useState, useCallback } from 'react';
import { getUser } from '../../api';
import useApplicationSession from '../../session/UserSession';
import DeclarationFrom from '../../form/subscription/DeclarationForm';

const Declaration = () => {
    const [declaration, setDeclaration] = useState({
        statement: null,
        loans: [],
        livingExpense: null,
        relationships: [],
    });
    const token = useApplicationSession();
    const getUserInfo = useCallback(() => {
        if (token) {
            getUser({ token })
                .then((response) => {
                    const { statement, loans, livingExpense, relationships } = response.data;
                    setDeclaration({
                        statement,
                        loans,
                        livingExpense,
                        relationships,
                    });
                })
                .catch((error) => {});
        }
    }, [token]);

    useEffect(() => {
        getUserInfo();
    }, [getUserInfo]);

    return (
        <div test_id="subscription-declaration" className="subscriptionContentContainer">
            <DeclarationFrom
                token={token}
                reload={getUserInfo}
                value={{
                    statement: declaration.statement,
                    loans: declaration.loans,
                    livingExpense: declaration.livingExpense,
                    relationships: declaration.relationships,
                }}
            />
        </div>
    );
};

export default Declaration;
